<div
  *ngIf="settings$ | async as settings"
  class="settings">
  <!-- Membership List Settings -->
  <section
    *ngIf="'MINGA_PEOPLE_MANAGE' | hasPermission"
    class="section">
    <mg-membership-list-table
      [types]="LIST_TYPES"
      [hideHeader]="true">
    </mg-membership-list-table>
  </section>

  <!-- Enable Tools Settings -->
  <section class="section">
    <mg-text variant="header-md-secondary">
      {{ MESSAGES.SUBHEADING_FLEXTIME_TITLE }}
    </mg-text>
    <div
      fxLayout="column"
      fxLayoutGap="12px">
      <mg-setting-toggle
        [label]="MESSAGES.FTM_TEACHERS_ENABLE"
        [setting]="SETTINGS.FTM_TEACHERS_ENABLE">
      </mg-setting-toggle>
      <mg-setting-toggle
        [label]="MESSAGES.FTM_STAFF_ENABLE"
        [setting]="SETTINGS.FTM_STAFF_ENABLE">
      </mg-setting-toggle>
      <mg-setting-toggle
        *ngIf="kioskPermissions.isKioskFeatureEnabled()"
        [setting]="SETTINGS.FTM_KIOSK"
        [label]="MESSAGES.FTM_KIOSK_ENABLE"
        (valueChange)="openDisclaimer($event)">
      </mg-setting-toggle>
      <mg-setting-toggle
        [label]="MESSAGES.FTM_AUTO_END_HALL_PASS_ON_CHECK_IN"
        [setting]="SETTINGS.FTM_AUTO_END_HALL_PASS_ON_CHECK_IN"
        [helpTooltip]="MESSAGES.FTM_AUTO_END_HALL_PASS_ON_CHECK_IN_TOOLTIP">
      </mg-setting-toggle>
      <mg-setting-toggle
        [label]="MESSAGES.FTM_RESTRICT_CHECK_IN_TIMES"
        [setting]="SETTINGS.FTM_RESTRICT_CHECK_IN_TIMES"
        [helpTooltip]="MESSAGES.FTM_RESTRICT_CHECK_IN_TIMES_TOOLTIP">
      </mg-setting-toggle>
      <mg-setting-toggle
        [label]="MESSAGES.FTM_ENABLE_TARDY_CHECK_IN"
        [setting]="SETTINGS.FTM_ENABLE_TARDY_CHECK_IN"
        (valueChange)="tardyCheckInChange($event)">
      </mg-setting-toggle>
      <div
        *ngIf="
          (isPbisEnabled$ | async) &&
          (behaviorSelectOptions$ | async)?.length > 0 &&
          settings[SETTINGS.FTM_ENABLE_TARDY_CHECK_IN]
        "
        class="tw-flex tw-flex-column tw-gap-3">
        <div class="tw-flex tw-justify-between tw-items-center">
          <div class="tw-flex">
            <mg-text
              element="span"
              variant="body-md"
              color="surface">
              {{ MESSAGES.FTM_AUTO_ASSIGN_BEHAVIOR }}
            </mg-text>
            <mg-tooltip [label]="MESSAGES.FTM_AUTO_ASSIGN_BEHAVIOR_TOOLTIP"> </mg-tooltip>
          </div>

          <mg-form-toggle
            [value]="autoTardyIsEnabled.value"
            (valueChange)="autoTardyIsEnabled.setValue($event)"></mg-form-toggle>
        </div>

        <div *ngIf="autoTardyIsEnabled.value">
          <mg-form-select
            id="flex-auto-assign-behavior-setting"
            [placeholder]="MESSAGES.FTM_AUTO_ASSIGN_SELECT_PLACEHOLDER"
            [options]="behaviorSelectOptions$ | async"
            [closeOnSelect]="true"
            [searchable]="true"
            [value]="(currentAutoAssignBehavior$ | async) || undefined"
            (selectionChanged)="updateAutoAssignBehavior($event)">
            <ng-template let-item="item">
              <mg-form-select-option [option]="item"></mg-form-select-option>
            </ng-template>
          </mg-form-select>
        </div>
      </div>
    </div>
  </section>
</div>
